import features from "../data/features";
import styles from "./WhyUs.module.css";

export default function WhyUs() {
  return (
    <section id="why-us" className={styles.section}>
      <div className={styles.glowTopRight} />
      <div className={styles.glowBottomLeft} />

      <div className={styles.inner}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>Our Promise</p>
          <h2 className={styles.title}>Why Choose Us?</h2>
          <p className={styles.subtitle}>Trusted since 2002 · NGJA Licensed</p>
          <div className={styles.divider} />
        </div>

        <div className={styles.grid}>
          {features.map((f) => (
            <div key={f.title} className={styles.card}>
              <div className={styles.icon}>{f.icon}</div>
              <h3 className={styles.cardTitle}>{f.title}</h3>
              <p className={styles.cardDesc}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
